import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import LogsTable from 'app/components/LogsTable'
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import {scanForResults} from 'app/utils/dynamo.js'

const useStyles = makeStyles({
    container: {
      padding: 10,
    },
    refreshButton: { 
      marginLeft: 10, 
    }
});



let tableConfig = [ 
  { title: "Function", id: "function"}, 
  { title: "Date", id: "date"}, 
  { title: "Time", id: "time"}, 
  { title: "Run Type", id: "runType"},
  { title: "Status", id: "status", type: "badge"}, 
]

export default function HomeView(props) { 
    const classes = useStyles();
    const [data, setData] = useState([])

    const downloadLogs = async (refresh = false) => { 
        let result = await scanForResults(undefined, refresh)
        console.log("Retreived results: ", result["Items"].length)
        let final = result["Items"].sort((a, b) => (a.timestamp < b.timestamp) ? 1 : -1)
        setData(final)
    }

    useEffect(() => {
      downloadLogs()
    }, []);


    return(
    <div className={classes.container}>
        <h1>Activity  
          <IconButton aria-label="refresh" onClick={()=>downloadLogs(true)} className={classes.refreshButton}>
            <RefreshIcon color="primary"/>
          </IconButton>
      </h1> 

        <LogsTable data={data} config={tableConfig}/>

    </div>)
} 
